// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// stimulus-flatpickr: Turbo-compatible datepicker wrapper
// https://github.com/adrienpoly/stimulus-flatpickr
// NOTE: This registration is for an npm package, not a local *_controller.js file,
// so `bin/rails stimulus:manifest:update` does NOT know about it and will strip it
// when regenerating this file. Re-add this block after running that task.
import Flatpickr from "stimulus-flatpickr"
application.register("flatpickr", Flatpickr)

import ActivePageController from "./active_page_controller"
application.register("active-page", ActivePageController)

import AgreementSettingsController from "./agreement_settings_controller"
application.register("agreement-settings", AgreementSettingsController)

import AiAssistantController from "./ai_assistant_controller"
application.register("ai-assistant", AiAssistantController)

import ApplicationFormController from "./application_form_controller"
application.register("application-form", ApplicationFormController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import DataSubscriptionController from "./data_subscription_controller"
application.register("data-subscription", DataSubscriptionController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DocumentManagerController from "./document_manager_controller"
application.register("document-manager", DocumentManagerController)

import DocumentUploadController from "./document_upload_controller"
application.register("document-upload", DocumentUploadController)

import EmailTemplatePickerController from "./email_template_picker_controller"
application.register("email-template-picker", EmailTemplatePickerController)

import ExternalSigningController from "./external_signing_controller"
application.register("external-signing", ExternalSigningController)

import FitTextController from "./fit_text_controller"
application.register("fit-text", FitTextController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineFieldEditorController from "./inline_field_editor_controller"
application.register("inline-field-editor", InlineFieldEditorController)

import ListSubscriptionController from "./list_subscription_controller"
application.register("list-subscription", ListSubscriptionController)

import MarketIntelligenceFilterGroupController from "./market_intelligence_filter_group_controller"
application.register("market-intelligence-filter-group", MarketIntelligenceFilterGroupController)

import MenuBadgeController from "./menu_badge_controller"
application.register("menu-badge", MenuBadgeController)

import MobileSidebarController from "./mobile_sidebar_controller"
application.register("mobile-sidebar", MobileSidebarController)

import RailController from "./rail_controller"
application.register("rail", RailController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import OtpModalController from "./otp_modal_controller"
application.register("otp-modal", OtpModalController)

import PackageCompletionController from "./package_completion_controller"
application.register("package-completion", PackageCompletionController)

import PdfSigningController from "./pdf_signing_controller"
application.register("pdf-signing", PdfSigningController)

import PhotoSortableController from "./photo_sortable_controller"
application.register("photo-sortable", PhotoSortableController)

import PlaceholderInsertController from "./placeholder_insert_controller"
application.register("placeholder-insert", PlaceholderInsertController)

import ReportInputController from "./report_input_controller"
application.register("report-input", ReportInputController)

import SaveStatusController from "./save_status_controller"
application.register("save-status", SaveStatusController)

import ScreenSizeController from "./screen_size_controller"
application.register("screen-size", ScreenSizeController)

import SessionTimeoutController from "./session_timeout_controller"
application.register("session-timeout", SessionTimeoutController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)


import TenancySlideoverController from "./tenancy_slideover_controller"
application.register("tenancy-slideover", TenancySlideoverController)

import TimelineController from "./timeline_controller"
application.register("timeline", TimelineController)

import ReportChartController from "./report_chart_controller"
application.register("report-chart", ReportChartController)

import TimelineSubscriptionController from "./timeline_subscription_controller"
application.register("timeline-subscription", TimelineSubscriptionController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TurboScriptsController from "./turbo_scripts_controller"
application.register("turbo-scripts", TurboScriptsController)

import VersionNotificationController from "./version_notification_controller"
application.register("version-notification", VersionNotificationController)

import ViewingBookingController from "./viewing_booking_controller"
application.register("viewing-booking", ViewingBookingController)

import ViewingRescheduleController from "./viewing_reschedule_controller"
application.register("viewing-reschedule", ViewingRescheduleController)
